import { FC } from 'react';

import { confirmSignUp, resendSignUpCode, signIn } from 'aws-amplify/auth';
import { codeResponseErrorsMap } from 'constants/confirmationCodeResponse';
import { FormikHelpers } from 'formik';

import usePromiseStatus from 'hooks/usePromiseStatus';

import { IStepFormProps as Props } from 'interfaces/auth';
import { IEnterCodeStepValues } from 'interfaces/confirmationCode';

import { useAuthModalsContext } from 'components/AuthModals';
import { ConfirmationCodeForm } from 'components/ConfirmationCodeForm/ConfirmationCodeForm';
import { useSetUpPasswordContext } from 'components/SetUpPassword/SetUpPasswordContextProvider/SetUpPasswordContextProvider';

export const EnterCodeStep: FC<Props> = ({ onClose }) => {
  const { prevStep } = useSetUpPasswordContext();
  const { setUpData } = useAuthModalsContext();

  const { track, isPending } = usePromiseStatus();

  const submitHandler = async ({ code }: IEnterCodeStepValues, actions: FormikHelpers<IEnterCodeStepValues>) => {
    try {
      const signUpData = await track(confirmSignUp({ username: setUpData.email, confirmationCode: code }));

      if (signUpData.isSignUpComplete) {
        actions.setFieldError('code', '');

        await track(signIn({ username: setUpData.email, password: setUpData.password }));
      }
      onClose();
    } catch (error) {
      if (error instanceof Error) {
        error instanceof Error && actions.setFieldError('code', codeResponseErrorsMap.get(error.name));
      }
    }
  };

  return (
    <ConfirmationCodeForm
      emailValue={setUpData.email}
      isPending={isPending}
      backClickHandler={prevStep}
      closeClickHandler={onClose}
      resendCodeHandler={resendSignUpCode}
      onSubmit={submitHandler}
    />
  );
};
